<div class="brands-container">
    <div class="dialog-header f-main-between f-cross-center px-8 py-16">
        <h2 class="m-0 dialogTitle font-bold">All the brands offering discounts on cloudigo...</h2>
        <button mat-dialog-close mat-icon-button color="primary">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    @if(items().length){
        <div id="brandsContent" class="row cgap-12 rgap-12 mx-24">
            @for(brand of items(); track brand._id){
                <div class="brand-icon" [routerLink]="['/brands', brand.slug]" (click)="this.dialogRef.close()">
                    <img [src]="brand.logo_url | bucket" [alt]="brand.name" style="cursor: pointer;" [fallback]/>
                </div>
            }
        </div>
        <div class="row">
            <div mat-dialog-actions>
                <button mat-stroked-button mat-dialog-close>
                    <mat-icon>chevron_right</mat-icon>
                    <span>Close</span>
                    <mat-icon iconPositionEnd>chevron_left</mat-icon>
                </button>
            </div>
        </div>
    } @else {
        <div class="loaderDiv">
            <div class="loader"></div>
        </div>
    }
</div>